/**
 * Der Kontenrahmen von Fördertechnik Werl — SKR03, angepasst. Übernommen aus dem vom Kunden
 * gelieferten Kontenplan (206 Konten) und die einzige Quelle dafür, welche Sachkonten
 * es GIBT: Kontierung und Export prüfen dagegen, statt einem Freitextfeld zu vertrauen. Ein
 * erfundenes Konto darf den Steuerberater nie erreichen.
 *
 * Sachkonten sind vierstellig, Personenkonten daher fünfstellig:
 * Debitoren 10000–69999, Kreditoren 70000–99999.
 */
export type LedgerAccountKind = 'guv' | 'bilanz';

export interface LedgerAccount {
  readonly number: string;
  readonly name: string;
  readonly kind: LedgerAccountKind;
}

export const chartOfAccounts: readonly LedgerAccount[] = [
  { number: '30', name: "Lizenz Computer Programm", kind: 'bilanz' },
  { number: '320', name: "PKW", kind: 'bilanz' },
  { number: '350', name: "LKW", kind: 'bilanz' },
  { number: '380', name: "sonstige Transportmittel", kind: 'bilanz' },
  { number: '400', name: "Betriebsausstattung", kind: 'bilanz' },
  { number: '410', name: "Geschäftsausstattung", kind: 'bilanz' },
  { number: '420', name: "Büroeinrichtung", kind: 'bilanz' },
  { number: '480', name: "GWG bis 800,-€", kind: 'bilanz' },
  { number: '800', name: "gezeichnetes Kapital", kind: 'bilanz' },
  { number: '860', name: "Gewinnvortrag vor Verwendung (JA)", kind: 'bilanz' },
  { number: '868', name: "Verlustvortrag vor Verwendung (JA)", kind: 'bilanz' },
  { number: '956', name: "Gewerbesteuerrückstellung", kind: 'bilanz' },
  { number: '961', name: "Urlaubsrückstellungen", kind: 'bilanz' },
  { number: '963', name: "Körperschaftsteuerrückstellung", kind: 'bilanz' },
  { number: '970', name: "Rückst. f. ungewisse Verbindl.", kind: 'bilanz' },
  { number: '977', name: "Rückstellungen für Abschluss u. Prüfung", kind: 'bilanz' },
  { number: '980', name: "ARAP Versicherungen", kind: 'bilanz' },
  { number: '1000', name: "Kasse", kind: 'bilanz' },
  { number: '1200', name: "Sparkasse Werl Kto-Nr. 32821", kind: 'bilanz' },
  { number: '1201', name: "Sparkasse - Tagesgeldkonto", kind: 'bilanz' },
  { number: '1202', name: "Sparkasse Werl - Spezialtransporte Kto. Nr. 69045", kind: 'bilanz' },
  { number: '1380', name: "Geldtransit", kind: 'bilanz' },
  { number: '1410', name: "Forderungen aus LuL Inland", kind: 'bilanz' },
  { number: '1411', name: "Forderungen aus LuL EU", kind: 'bilanz' },
  { number: '1412', name: "Forderungen aus Drittland", kind: 'bilanz' },
  { number: '1501', name: "Sonstige Forderungen", kind: 'bilanz' },
  { number: '1520', name: "Forderungen gegenüber Krankenkassen aus Aufwendung", kind: 'bilanz' },
  { number: '1530', name: "Forderungen gegen Personal", kind: 'bilanz' },
  { number: '1540', name: "Forderung aus Gewerbesteuerüberzahlung (JA)", kind: 'bilanz' },
  { number: '1545', name: "Forderungen USt-Vorauszahlung (JA)", kind: 'bilanz' },
  { number: '1549', name: "Körperschaftsteuerrückforderung (JA)", kind: 'bilanz' },
  { number: '1570', name: "Abziehbare Vorsteuer (JA)", kind: 'bilanz' },
  { number: '1571', name: "Vorsteuer 7 %", kind: 'bilanz' },
  { number: '1573', name: "Vorsteuer EG Erwerbe 19 %", kind: 'bilanz' },
  { number: '1576', name: "Vorsteuer 19%", kind: 'bilanz' },
  { number: '1577', name: "Vorsteuer n. 13b UStG 19%", kind: 'bilanz' },
  { number: '1588', name: "Bezahlte Einfuhrumsatzsteuer", kind: 'bilanz' },
  { number: '1590', name: "Durchlaufende Posten", kind: 'bilanz' },
  { number: '1591', name: "Durchlaufende Posten Avise", kind: 'bilanz' },
  { number: '1610', name: "Sonst Verbindlichkt aus LuL", kind: 'bilanz' },
  { number: '1611', name: "Verbindlichkeiten aus EG LuL", kind: 'bilanz' },
  { number: '1612', name: "Verbindlichkeiten aus Drittlan", kind: 'bilanz' },
  { number: '1665', name: "Gesellschafterdarlehen Denner", kind: 'bilanz' },
  { number: '1701', name: "sonstige Verbindlichkeiten", kind: 'bilanz' },
  { number: '1702', name: "Darlehen Stabilo Landtechnik GmbH", kind: 'bilanz' },
  { number: '1740', name: "Verbindlichkeiten Lohn und Gehalt", kind: 'bilanz' },
  { number: '1741', name: "Verbindlichkeiten Lohnsteuer, Kirchensteuer, Soli", kind: 'bilanz' },
  { number: '1742', name: "Verbindlichkeiten soziale Sicherheit", kind: 'bilanz' },
  { number: '1748', name: "Verbind. Einbehalt. AN", kind: 'bilanz' },
  { number: '1750', name: "Vbl.aus VWL", kind: 'bilanz' },
  { number: '1755', name: "Lohn- und Gehaltsverrechnung", kind: 'bilanz' },
  { number: '1771', name: "Umsatzsteuer 7 %", kind: 'bilanz' },
  { number: '1776', name: "Umsatzsteuer 19 %", kind: 'bilanz' },
  { number: '1777', name: "Umsatzsteuer 16 %", kind: 'bilanz' },
  { number: '1778', name: "Umsatzsteuer 16 %", kind: 'bilanz' },
  { number: '1779', name: "Umsatzsteuer innerg Erwerb 19%", kind: 'bilanz' },
  { number: '1780', name: "Umsatzsteuer Vorauszahlung", kind: 'bilanz' },
  { number: '1790', name: "Umsatzsteuer Vorjahr", kind: 'bilanz' },
  { number: '1797', name: "Verbindlichkeiten aus Umsatzsteuer-Vorauszahlungen", kind: 'bilanz' },
  { number: '2100', name: "Zinsen", kind: 'guv' },
  { number: '2110', name: "ZINSAUFWAND L.U.L.", kind: 'guv' },
  { number: '2117', name: "Zinsen Gesellschafterdarlehen", kind: 'guv' },
  { number: '2118', name: "Zinsen kurzfr. VBL VSt. 19 %", kind: 'guv' },
  { number: '2200', name: "Körperschaftssteuer", kind: 'guv' },
  { number: '2203', name: "Körperschaftsteuer Vorjahre", kind: 'guv' },
  { number: '2208', name: "Solidaritätszuschlag", kind: 'guv' },
  { number: '2209', name: "Solidaritätszuschlag (Vorjahre)", kind: 'guv' },
  { number: '2210', name: "Soli.Zusch. Erstattung für Vorjahre", kind: 'guv' },
  { number: '2213', name: "Kapitalertragssteuer", kind: 'guv' },
  { number: '2281', name: "Gewerbest. und Gewerbesteuererst.", kind: 'guv' },
  { number: '2308', name: "Bußgelder", kind: 'guv' },
  { number: '2310', name: "Anlagenabgänge Sachanl. Buchverlust", kind: 'guv' },
  { number: '2400', name: "Forderungsverlust ohne Steuer", kind: 'guv' },
  { number: '2406', name: "Forderungsverlust übl Höhe 19 %", kind: 'guv' },
  { number: '2650', name: "Zinserträge (neutral)", kind: 'guv' },
  { number: '2700', name: "Sonstige Erträge 19 %", kind: 'guv' },
  { number: '2701', name: "Sonstige Erträge 7 %", kind: 'guv' },
  { number: '2710', name: "Sonstige Erträge steuerfrei", kind: 'guv' },
  { number: '2732', name: "Erträge abgeschr Forderung 19 %", kind: 'guv' },
  { number: '2742', name: "Versicherungsentschädigungen, Schadenersatz", kind: 'guv' },
  { number: '2743', name: "Investitionszuschüsse (JA)", kind: 'guv' },
  { number: '2749', name: "Erstattungen Aufwendungsausgleichsgesetz", kind: 'guv' },
  { number: '3200', name: "Wareneingang Drittländer", kind: 'guv' },
  { number: '3349', name: "WE ohne Vst-Abzug (Privatkauf)", kind: 'guv' },
  { number: '3400', name: "Wareneingang Inland 19 % MwSt.", kind: 'guv' },
  { number: '3425', name: "Innergem Erwerb 19%", kind: 'guv' },
  { number: '3730', name: "erhalt Skonti ohne Vorsteuer", kind: 'guv' },
  { number: '3732', name: "erhalt Skonti ohne Vorsteuer", kind: 'guv' },
  { number: '3735', name: "erhalt Skonti EU", kind: 'guv' },
  { number: '3737', name: "erhalt Skonti 19 % Vorsteuer", kind: 'guv' },
  { number: '3748', name: "Skonti innerg. Erwerb 19%", kind: 'guv' },
  { number: '3800', name: "Anschaffungsnebenkosten Inland 19%", kind: 'guv' },
  { number: '3801', name: "Anschaffungsnebenkoste EG", kind: 'guv' },
  { number: '3802', name: "Anschaffungsnebenkoste Dritt.", kind: 'guv' },
  { number: '3850', name: "Zölle u. Einfuhrabgaben", kind: 'guv' },
  { number: '3950', name: "Bestandsveränderung Waren", kind: 'guv' },
  { number: '3989', name: "Bestand Waren", kind: 'bilanz' },
  { number: '4100', name: "Löhne u Gehälter", kind: 'guv' },
  { number: '4111', name: "Änderung Urlaubsrückstellung", kind: 'guv' },
  { number: '4120', name: "Gehälter", kind: 'guv' },
  { number: '4130', name: "gesetzl. soziale Aufwendungen", kind: 'guv' },
  { number: '4138', name: "Beiträge Berufsgenossenschaft +Insolvenzgeldumlage", kind: 'guv' },
  { number: '4140', name: "freiw. soziale Aufwendg. LSt.frei (19 % MwSt.)", kind: 'guv' },
  { number: '4142', name: "freiw.soziale Aufwendg.LSt.frei 7 %", kind: 'guv' },
  { number: '4145', name: "freiw. soziale Aufwendg. LSt.pfl.", kind: 'guv' },
  { number: '4149', name: "30% pauschale Steuerzuwendungen AN", kind: 'guv' },
  { number: '4155', name: "Zuschüsse der Agentur f.Arbeit", kind: 'guv' },
  { number: '4165', name: "Aufwand für Altersversorgung", kind: 'guv' },
  { number: '4170', name: "Vermögensw. Leistungen", kind: 'guv' },
  { number: '4175', name: "Fahrtkostenerstattung Whg-Arbst.", kind: 'guv' },
  { number: '4180', name: "Sonstige Personalkosten", kind: 'guv' },
  { number: '4195', name: "Löhne für Minijobs", kind: 'guv' },
  { number: '4198', name: "Kosten Leiharbeiter", kind: 'guv' },
  { number: '4199', name: "Pauschale Steuer für Aushilfen", kind: 'guv' },
  { number: '4200', name: "Raumkosten", kind: 'guv' },
  { number: '4210', name: "Miete 19 % MwSt.", kind: 'guv' },
  { number: '4260', name: "Instandhaltung betrieb. Räume", kind: 'guv' },
  { number: '4320', name: "Gewerbesteuer Vorauszahlungen", kind: 'guv' },
  { number: '4360', name: "Versicherungen (19 %)", kind: 'guv' },
  { number: '4380', name: "Beiträge (19 %)", kind: 'guv' },
  { number: '4390', name: "Sonstige Abgaben", kind: 'guv' },
  { number: '4391', name: "Gebühren", kind: 'guv' },
  { number: '4397', name: "Strafen steuerlich nicht abzugsfähig", kind: 'guv' },
  { number: '4510', name: "Kfz.-Steuer", kind: 'guv' },
  { number: '4511', name: "LKW Kfz.-Steuer", kind: 'guv' },
  { number: '4520', name: "KfZ-Versicherungen", kind: 'guv' },
  { number: '4521', name: "LKW Kfz-Versicherungen", kind: 'guv' },
  { number: '4530', name: "laufende KFZ-Kosten 19%", kind: 'guv' },
  { number: '4531', name: "Fahrzeugkosten ohne VST", kind: 'guv' },
  { number: '4540', name: "Spezialtransporte LKW lfd. Kosten 19%", kind: 'guv' },
  { number: '4541', name: "Spezialtransporte LKW lfd. Kosten EU", kind: 'guv' },
  { number: '4560', name: "Mautgebühren", kind: 'guv' },
  { number: '4561', name: "Spezialtransporte Maut LKW", kind: 'guv' },
  { number: '4570', name: "KFZ Leasing", kind: 'guv' },
  { number: '4607', name: "Werbekosten EU", kind: 'guv' },
  { number: '4608', name: "Werbekosten 7 % MWSt", kind: 'guv' },
  { number: '4609', name: "Werbekosten ohne MWSt.", kind: 'guv' },
  { number: '4610', name: "Sonstige Werbekosten 19 %", kind: 'guv' },
  { number: '4630', name: "Geschenke abzugsfähig mit § 37b EstG", kind: 'guv' },
  { number: '4631', name: "Geschenke bis 30 € 7%", kind: 'guv' },
  { number: '4632', name: "Pauschale Steuer für Geschenke abzugsfähig", kind: 'guv' },
  { number: '4635', name: "Geschenke über 30 € 19%", kind: 'guv' },
  { number: '4636', name: "Geschenke über 30 € 7%", kind: 'guv' },
  { number: '4650', name: "Bewirtungskosten 19 %", kind: 'guv' },
  { number: '4654', name: "Bewirtungskosten 0% MwSt.", kind: 'guv' },
  { number: '4655', name: "Bewirtungen 7% MWSt", kind: 'guv' },
  { number: '4660', name: "Reisekosten nicht abzugsfähig", kind: 'guv' },
  { number: '4662', name: "Reisekosten 7 %", kind: 'guv' },
  { number: '4664', name: "Reisekosten 19 %", kind: 'guv' },
  { number: '4665', name: "Reisekosten 0 % MWSt", kind: 'guv' },
  { number: '4666', name: "Übernachtungskosten 7 % MWSt.", kind: 'guv' },
  { number: '4667', name: "Übernachtungskosten 0 % MWSt.", kind: 'guv' },
  { number: '4700', name: "Kosten Warenabgabe 19 %", kind: 'guv' },
  { number: '4701', name: "Kosten Warenabgabe steuerfrei (EU, Drittland)", kind: 'guv' },
  { number: '4730', name: "Spezialtransporte Ausgangsfrachten 19 %", kind: 'guv' },
  { number: '4731', name: "Spezialtransporter Ausgangsfrachten EU steuerfrei", kind: 'guv' },
  { number: '4800', name: "Aufwand für Reparaturen 19%", kind: 'guv' },
  { number: '4806', name: "EDV-Kosten", kind: 'guv' },
  { number: '4810', name: "Mietleasing", kind: 'guv' },
  { number: '4822', name: "Abschreibung immaterielle VermG", kind: 'guv' },
  { number: '4830', name: "Abschreibungen auf Sachanlagen", kind: 'guv' },
  { number: '4832', name: "Normalabschreibungen kfz", kind: 'guv' },
  { number: '4855', name: "Sofortabschreibung GWG", kind: 'guv' },
  { number: '4900', name: "sonst. betriebliche Aufwendungen 19%", kind: 'guv' },
  { number: '4901', name: "sonstige betriebl Aufwendungen ohne Steuer (19%)", kind: 'guv' },
  { number: '4909', name: "Fremdleistungen/Fremdarbeiten", kind: 'guv' },
  { number: '4910', name: "Porto 19%", kind: 'guv' },
  { number: '4920', name: "Telefonkosten 19%", kind: 'guv' },
  { number: '4930', name: "Büromaterial (19%)", kind: 'guv' },
  { number: '4940', name: "Zeitschriften Bücher 7 % MWSt.", kind: 'guv' },
  { number: '4945', name: "Fortbildungskosten (JA)", kind: 'guv' },
  { number: '4950', name: "Rechts- und Beratungskosten 19%", kind: 'guv' },
  { number: '4951', name: "Rechts- und Beratungskosten ohne Steuer", kind: 'guv' },
  { number: '4960', name: "Miete/Leasing Büro/Tele/Brandm 19 %", kind: 'guv' },
  { number: '4961', name: "Wartung/Rep/Kosten EDV/Büro 19 %", kind: 'guv' },
  { number: '4966', name: "Nebenkosten Geldverkehr 19%", kind: 'guv' },
  { number: '4969', name: "Aufwendungen für Abfallbeseitigung", kind: 'guv' },
  { number: '4970', name: "Nebenkosten Geldverkehr", kind: 'guv' },
  { number: '4992', name: "Kalk.Zinsen Gesellschaft.darl./Stabilo", kind: 'guv' },
  { number: '4993', name: "Kalkulatorische Abschreibungen", kind: 'guv' },
  { number: '8000', name: "Umsatzerlöse 19 % MWSt", kind: 'guv' },
  { number: '8001', name: "Umsatzerlöse 7%", kind: 'guv' },
  { number: '8002', name: "Umsatzerlöse 7% Spezialtransporte", kind: 'guv' },
  { number: '8100', name: "Erlöse Drittland", kind: 'guv' },
  { number: '8110', name: "sonst steuerfreie Erlöse", kind: 'guv' },
  { number: '8125', name: "Steuerfreie innerg Lieferungen", kind: 'guv' },
  { number: '8337', name: "Erlöse aus Leistungen § 13b", kind: 'guv' },
  { number: '8400', name: "Erlöse", kind: 'guv' },
  { number: '8401', name: "Sonstige Erlöse 19 % MwSt.", kind: 'guv' },
  { number: '8409', name: "Speditionserlöse 19 % MWSt.", kind: 'guv' },
  { number: '8411', name: "Speditionserlöse EU 0% MWST.", kind: 'guv' },
  { number: '8521', name: "Erlöse aus Abfallverwertung", kind: 'guv' },
  { number: '8590', name: "Verrechnete sonstige Sachbezüge (keine Waren)", kind: 'guv' },
  { number: '8605', name: "Kurzarbeitsgeld - Sonstige betriebliche Erträge", kind: 'guv' },
  { number: '8611', name: "verrechnung sonstige Sachbezüge", kind: 'guv' },
  { number: '8700', name: "Erlösschmälerungen 19 %", kind: 'guv' },
  { number: '8724', name: "Erlösschmälerungen EU", kind: 'guv' },
  { number: '8725', name: "Erlösschmälerungen Drittl", kind: 'guv' },
  { number: '8730', name: "Gewährte Skonti D", kind: 'guv' },
  { number: '8731', name: "Gewährte Skonti EU 19 %", kind: 'guv' },
  { number: '8732', name: "Gewährte Skonti Drittland", kind: 'guv' },
  { number: '8736', name: "Gewährte Skonti 19%", kind: 'guv' },
  { number: '8790', name: "Preisnachlass 19%", kind: 'guv' },
  { number: '9053', name: "G+V 31.12.", kind: 'bilanz' },
  { number: '9090', name: "Kursregulierung ATS/SFR", kind: 'guv' },
  { number: '10000', name: "Lagerbuchungen Dummy Konto", kind: 'guv' },
];

const accountIndex = new Map<string, LedgerAccount>(chartOfAccounts.map((account) => [account.number, account]));

export function findAccount(number: string): LedgerAccount | undefined {
  return accountIndex.get(number.trim());
}

/** Does this Sachkonto exist in the chart? The gate every Kontierung has to pass. */
export function isKnownAccount(number: string): boolean {
  return accountIndex.has(number.trim());
}

export function accountLabel(number: string): string {
  const account = findAccount(number);
  return account ? `${account.number} · ${account.name}` : number;
}

/** Personenkonto ranges — derived from the four-digit Sachkonto length (DATEV rule). */
export const debitorRange = { from: 10000, to: 69999 } as const;
export const creditorRange = { from: 70000, to: 99999 } as const;

export function isDebitorNumber(number: string): boolean {
  return /^\d{5}$/.test(number.trim()) && Number(number) >= debitorRange.from && Number(number) <= debitorRange.to;
}

export function isCreditorNumber(number: string): boolean {
  return /^\d{5}$/.test(number.trim()) && Number(number) >= creditorRange.from && Number(number) <= creditorRange.to;
}
